import { render, staticRenderFns } from "./AufgabenComponentCreateAufgabe.vue?vue&type=template&id=03b18a85"
import script from "./AufgabenComponentCreateAufgabe.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentCreateAufgabe.vue?vue&type=script&lang=js"
import style0 from "./AufgabenComponentCreateAufgabe.vue?vue&type=style&index=0&id=03b18a85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports